import {NgModule} from "@angular/core";
import {DeltaDragDirective} from "./delta.drag.directive";
import {TouchDragDirective} from "./touch.drag.directive";

@NgModule({
	declarations:[DeltaDragDirective,TouchDragDirective],
	exports:[DeltaDragDirective,TouchDragDirective]
})
export class DraggingModule{
}
